export const layoutLocators = {
  serviceLoadingIndicator: 'Layout-ServiceLoadingIndicator',
};
